import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, ModalController, Events, AlertController, Navbar } from 'ionic-angular';
import { HttpClient } from '../../../../services/HttpClient';
import { CustomToast } from '../../../../util/CustomToast';
import * as moment from 'moment';
import { ImageSelector } from '../../../../util/imageSelector/imageSelector';

@Component({
  selector: 'page-new',
  templateUrl: 'new.html',
  providers : [HttpClient, CustomToast]
})
export class NewPage {

  modalCtrl : ModalController;
	
  httpClient : HttpClient;
  baseUrl;

  image = {
    id : -1,
    filename : 'addimage.png'
  };

  categories;
  types;

  thenew = {
    id : -1,
    state : 0,
    photo : '',
    video : '',
    title_es : '',
    title_en : '',
    summary_es : '',
    summary_en : '',
    tags_es : '',
    tags_en : '',
    url : '',
    press : '',
    date : '',
    idCategory : -1,
    idType : -1,
    idOwner : 1
  };

  customToast : CustomToast;
  events : Events;
  alertCtrl : AlertController;

  minDate = moment().subtract(20,'years').toISOString();
  maxDate = moment().add(20,'years').toISOString();

  @ViewChild(Navbar) navBar: Navbar;

	constructor(public navCtrl: NavController, public navParams: NavParams, httpClient : HttpClient,customToast : CustomToast,modalCtrl : ModalController, events : Events, alertCtrl : AlertController) {
		this.modalCtrl = modalCtrl;
    this.httpClient = httpClient;
    this.baseUrl = this.httpClient.getBaseUrl();

    this.customToast = customToast;
    this.events = events;
    this.alertCtrl = alertCtrl;
    let id = this.navParams.get('id');
    this.httpCallNew(id);
    this.httpCallTypes();
    this.httpCallCategories();
  }
  
  ionViewDidLoad() {
    this.navBar.backButtonClick = (e:UIEvent)=>{
     let alert = this.alertCtrl.create({
      title : '¿Seguro que deseas salir?',
      message : 'Los datos no guardados se perderán',
      buttons : [
        {
          text : 'Salir',
          handler : () =>{
            this.navCtrl.pop();
          }
        },
        {
          text : 'Cancelar',
          role : 'cancel'
        }
      ]
     });

     alert.present();
    }
  }

  onClickImage(){
    let modal = this.modalCtrl.create(ImageSelector);
    modal.present();
    modal.onDidDismiss(image => {
      if(image){
        this.image = image;
        this.thenew.photo = image.filename;
      }
    });
  }

  httpCallNew(id){
    this.httpClient.get('/news/'+id,(error,data)=>{
      if(!error){
        this.thenew = data.json();
        if(this.thenew.photo){
          this.image.filename = this.thenew.photo;
        }
      }
    });
  }

  httpCallTypes(){
    this.httpClient.get('/types?max=10000', (error,data)=>{
      this.types = data.json();
    });
  }

  httpCallCategories(){
    this.httpClient.get('/categories?max=10000', (error,data)=>{
      this.categories = data.json();
    });
  }

  httpUpdateNew(){
    this.thenew.date = this.thenew.date.split('T')[0];
    this.httpClient.put('/news',this.thenew,(error,data)=>{
      if(!error){
        this.customToast.showMessage('Noticia actualizada correctamente',2000);
        this.navCtrl.pop();
        this.events.publish('new:update');
      }
    });
  }

  onClickSave(){
    this.httpUpdateNew();
  }

  onClickDelete(){
    let alert = this.alertCtrl.create({
      title : '¿Estas seguro?',message : 'Vas a eliminar la información de esta noticia',
      buttons:[{
        text : 'No',
        role : 'cancel'
        },
        {
        text : 'Si',
        role : 'confirm',
          handler : ()=>{
            this.httpCallDelete();
          }
        }
      ]
    });
    alert.present();
  }

  httpCallDelete(){
    this.httpClient.delete('/news/'+this.thenew.id,(error,data)=>{
      if(!error){
        this.customToast.showMessage('Noticia eliminada correctamente',2000);
        this.navCtrl.pop();
        this.events.publish('new:delete');
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/dashboard/news/new/new.ts